import type { ReactNode } from 'react';
import React, { useEffect, useContext } from 'react';

import {
	ExperienceTrackerContext,
	END_OF_TRIAL_MODAL_EXPERIENCE,
} from '@confluence/experience-tracker';

import { useOperationalInfo } from '../store/operationalStore';
import { EndOfTrialModal } from '../EndOfTrialModal';
import { useLoadFeatureUsageToStore } from '../hooks/load-to-store/useLoadFeatureUsageToStore';
import { useLoadModalCoordinationToStore } from '../hooks/load-to-store/useLoadModalCoordinationToStore';
import { useGetOSBLink } from '../hooks/useGetOSBLink';
import { useExperimentInfo } from '../store/experimentInfoStore';
import { useHandleExperienceTrackerError } from '../hooks/useHandleExperienceTrackerError';
import { statsigCohorts } from '../experimentConstants';

export const DataLoader = ({ children }: { children: ReactNode }) => {
	useGetOSBLink();
	useLoadFeatureUsageToStore();
	useLoadModalCoordinationToStore();
	const { handleExperienceTrackerError } = useHandleExperienceTrackerError();

	const { epMessageReady, cohort } = useExperimentInfo();
	const { error, loading } = useOperationalInfo();

	const experienceTracker = useContext(ExperienceTrackerContext);
	// load this when cohort comes back (which modal experience to serve)
	useEffect(() => {
		experienceTracker.start({
			name: END_OF_TRIAL_MODAL_EXPERIENCE,
		});
	}, [experienceTracker]);

	useEffect(() => {
		if (error) {
			handleExperienceTrackerError();
		}
	}, [error, handleExperienceTrackerError]);

	if (loading || error || !epMessageReady || cohort !== statsigCohorts.TREATMENT) {
		return <>{children}</>;
	}

	return (
		<>
			{children}
			<EndOfTrialModal />
		</>
	);
};
